var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigateLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 219 219",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1059,-7882)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.425222,0,0,0.425222,1059.41,7882.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482.595,1.647L13.262,193.647C-6.477,201.722 -3.46,230.566 17.523,234.381L237.659,274.406L277.684,494.542C281.499,515.525 310.343,518.542 318.418,498.803L510.418,29.47C517.58,11.962 500.103,-5.516 482.595,1.647ZM306.592,415.024L276.995,252.242C275.406,243.5 268.564,236.658 259.822,235.069L97.04,205.472L451.666,60.398L306.592,415.024Z",
    style: {
      fill: "rgb(49,57,65)",
      fillRule: "nonzero"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateLight);
export default __webpack_public_path__ + "static/media/navigate_light.e9ea5072ed086e633cb26b5a0e845e8b.svg";
export { ForwardRef as ReactComponent };